import React, { useEffect, useState, useContext } from "react";
import apiClient from "../api/apiClient";
import "../css/KingStarline.css";
import "../css/mainhome.css";
import "../css/KingJackpot.css";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { LuGamepad2 } from "react-icons/lu";
import StarlineClosedModal from "../components/starlineclosedmodal";

// Icons
import clock1 from "../assets/icons/clock.svg";
import clock2 from "../assets/icons/clock2.svg";
import clockHeader from "../assets/icons/clock22.png";

const KingStarlineDashboard = () => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [closedGame, setClosedGame] = useState(null);
  const { user } = useContext(AppContext);

  const statItems = [
    { label: "Single Digit", value: "10/0" },
    { label: "Double Pana", value: "10/0" },
    { label: "Single Pana", value: "10/0" },
    { label: "Triple Pana", value: "10/0" },
  ];

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const registerId = localStorage.getItem("registerId");
        if (!registerId) return;

        const resp = await apiClient.post("/starline-game-list", {
          registerId,
        });

        if (resp?.data?.status && Array.isArray(resp.data.info)) {
          setGames(resp.data.info);
        } else {
          console.error("Unexpected starline response:", resp?.data);
        }
      } catch (e) {
        console.error("Error fetching starline games:", e);
      }
    };
    fetchGames();
  }, []);

  const handleGameClick = (game) => {
    if (!user?.accountStatus) {
      return;
    }
    if (game.playStatus) {
      navigate(`/starline/${game.gameId}`, {
        state: { gameName: game.gameName },
      });
    } else {
      setClosedGame(game);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="ksd-wrap">
        <header className="kjd-header">
          <button
            className="kjd-back"
            onClick={() => navigate(-1)}
            aria-label="Back"
          >
            ‹
          </button>
          <div className="kjd-title">Main Starline</div>
          <button
            className="kjd-history"
            onClick={() => navigate("/bids/starline-result-history")}
          >
            <img src={clockHeader} alt="clock" className="clock" />
            View History
          </button>
        </header>

        <div className="ksd-subheaders">
          <span className="ksd-sub-label">Rates</span>
          <span className="ksd-sub-label">Starline Chart</span>
        </div>

        <div className="ksd-stats">
          {statItems.map((it, i) => (
            <div key={it.label} className="ksd-stat">
              <span className="lab">{it.label} :</span>
              <span className="val">{it.value}</span>
              {i === 1 && <i className="v-sep" aria-hidden />}
            </div>
          ))}
        </div>

        <div className="ksd-list-headers">
           <span className="ksd-main-title">Starline Games</span>
           <button 
             className="ksd-view-history"
             onClick={() => navigate("/bids/starline-result-history")}
            >
              View History
           </button>
        </div>

        <div className="ksd-list">
          {games.map((g) => {
            const running = !!g.playStatus;
            return (
              <div
                key={g.gameId}
                className={`ksd-card ${running ? "running" : "closed"}`}
                onClick={() => handleGameClick(g)}
                role="button"
              >
                <div className="ksd-running-header">
                  <span>{running ? "Betting is Running Now" : "Betting is Closed for Today"}</span>
                </div>

                <div className="ksd-card-body">
                  <div className="ksd-icon-wrap">
                    <img 
                      src={running ? clock2 : clock1} 
                      alt="clock" 
                      className="ksd-state-icon" 
                    />
                  </div>

                  <div className="ksd-card-info">
                    <div className="ksd-time-val">{g.gameName}</div>
                    <div className="ksd-result-val">***_*</div>
                  </div>
                </div>

                <div className="ksd-card-footer">
                  {running ? (
                    <button
                      className="ksd-play-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGameClick(g);
                      }}
                    >
                      <LuGamepad2 className="gamepad-icon" />
                      Play Game
                    </button>
                  ) : (
                    <div className="ksd-closed-btn">
                      <span>CLOSED</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {closedGame && (
        <StarlineClosedModal
          game={closedGame}
          onClose={() => setClosedGame(null)}
        />
      )}
    </div>
  );
};

export default KingStarlineDashboard;